import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Group, Layout } from "@/comn/components";
import { useFetch, useModal, useResource, usePage } from "@/comn/hooks";
import { APIS_ADD_ITM } from "@/tz/go/egaz/osci/lpco/comn/services/OsciLpcoComnAppOfcrAddItmService";
/**
 * AMD Officer Additional Item Detail
 * !== 정정/취소 담당자 추가 항목 상세 ==!
 */
export const APP_AMD_RGST_OFCR_ADD_ITM = (props: any) => {

    useResource({
        defaultSchema: [],
    });

    const { pgeUid } = usePage();
    const { t } = useTranslation();
    const modal = useModal();
    const refAddItmList = useRef<any[]>([]);
    const refBfList = useRef<any[]>([]);  // Staging before rows for compare !== 정정 전 API 결과 보관 ==!

    // Resolve before list for compare !== 비교용 정정 전 목록 ==!
    const resolveBfOrigin = () => {
        if (refBfList.current.length > 0) return refBfList.current;
        return bfOfcrAddItmForm?.getValues?.()?.orginAdtnlItmList || [];
    };
    const [stateAddItmSchemas, setStateAddItmSchemas] = useState<any[] | undefined>([]);
    const refTemp = useRef<any[]>([]);
    const form = props.form;

    const displayMode = props.displayMode ?? "after";
    const isBefore = displayMode === "before";
    const canEditAfter = !isBefore && (props.ofcrAddItmEditable === true || props.param?.edit === true);
    
    const bfOfcrAddItmForm = props.bfOfcrAddItmForm ?? form?.appRgstOfcrAddItm;

    const isPreApp = props.param?.appClsfCd === "X";

    // const [appParam, setAppParam] = useState<any>({});
    // const [bfAppParam, setBfAppParam] = useState<any>({});

    // const bfForm = {
    //     addItmForm: {
    //         appRgstOfcrAddItm : {
    //             ...form.appRgstOfcrAddItm ,
    //         },
    //     },
    // };

    // 상위 화면 연동 콜백(있으면 사용)
    const onOfcrAddItmChange = props.onOfcrAddItmChange as ((change: boolean) => void) | undefined;
    const onOfcrAddItmChangeRef = useRef(onOfcrAddItmChange);
    onOfcrAddItmChangeRef.current = onOfcrAddItmChange;

    const onRegisterTabSave = props.onRegisterTabSave as ((tabCd: string, fn?: () => Promise<boolean>) => void) | undefined;
    const onRegisterTabValid = props.onRegisterTabValid as ((tabCd: string, fn?: () => Promise<boolean>) => void) | undefined;
    
    const ofcrAddItmForm = form?.appRgstOfcrAddItm;
    const prevCanEditAfterRef = useRef<boolean | undefined>(undefined);
    const loadedKeyRef = useRef<string | null>(null);

    // watch() 호출로 값 변경 시 리렌더 유도
    const watchedValues = !isBefore && ofcrAddItmForm?.watch ? ofcrAddItmForm.watch() : undefined;

    const appCdNo = props.param.appCdNo;
    const appId = props.param.appId;
    const areaCd = props.area;
    const itemNo = props.itemNo;
    const appDgr = props.param.appDgr;
    const appStatCd = props.param.appStatCd;

    const paramData = {
        additmCpntCd: areaCd,
        appCdNo: appCdNo,
        itmNo: itemNo,
        appDgr: appDgr,
        appStatCd: appStatCd,
        prcsRoleTpCd: props.param?.prcsRoleTpCd,
    };

    // !== before도 화면 R로 EXCU 표시필터 일치시켜 before/after 비교 정렬 ==!
    const bfParamData = {
        additmCpntCd: areaCd,
        appCdNo: props.bfParam?.appCdNo,
        itmNo: itemNo,
        appDgr: props.bfParam?.appDgr,
        appStatCd: props.bfParam?.appStatCd,
        prcsRoleTpCd: props.param?.prcsRoleTpCd,
    };

    const fetch = {
        getAdtnlItmValueList: useFetch({
            api: (id, data) => APIS_ADD_ITM.getAdtnlItmValueList(id, data),
            onSuccess: (data) => {
                const list = data.adtnlItmList?.content || [];
                refAddItmList.current = list;

                if (isBefore) {
                    form.appRgstOfcrAddItm?.setValue("orginAdtnlItmList", [...list]);
                    setStateAddItmSchemas(
                        APIS_ADD_ITM.getAdtnlItmSchemas(form.appRgstOfcrAddItm, list, false),
                    );
                    form.appRgstOfcrAddItm?.setEditable(false);
                    return;
                }

                const apiList = data.adtnlItmList?.content || [];
                const bfOrigin = resolveBfOrigin();
                const displayList =
                    apiList.length > 0 ? apiList : bfOrigin.map((row: any) => ({ ...row }));
                refAddItmList.current = displayList;
                form.appRgstOfcrAddItm?.setValue("orginAdtnlItmList", [...displayList]);
                setStateAddItmSchemas(
                    APIS_ADD_ITM.getAmdAdtnlItmSchemas(
                        form.appRgstOfcrAddItm,
                        apiList,
                        canEditAfter,
                        bfOrigin,
                        { hydrateValues: true },
                    ),
                );
                if (canEditAfter) {
                    form.appRgstOfcrAddItm?.setEditable(true);
                } else {
                    form.appRgstOfcrAddItm?.setEditable(false);
                }
                onOfcrAddItmChange?.(false);
            },
            onError: () => {},
            showToast: false,
        }),

        getBeforeAdtnlItmValueList: useFetch({
            api: (id, data) => APIS_ADD_ITM.getAdtnlItmValueList(id, data),
            onSuccess: (data) => {
                const bfList = data.adtnlItmList?.content || [];
                refBfList.current = [...bfList];
                bfOfcrAddItmForm?.setValue("orginAdtnlItmList", [...bfList]);
                fetch.getAdtnlItmValueList.fetch(appId, paramData);
            },
            onError: () => {},
            showToast: false,
        }),
        saveAdtnlItmValueList: useFetch({
            api: (data) => APIS_ADD_ITM.saveAdtnlItmValueList(props.param?.appId, data),
        }),
    };
    const handler = {
        isChangeByOrigin: useCallback(() => {
            const allValues = form?.appRgstOfcrAddItm ?.getValues?.() || {};
            const originList = allValues?.orginAdtnlItmList || [];
            if (!originList || originList.length === 0) return false;
            for (let i = 0; i < originList.length; i++) {
                const row = originList[i];
                const fieldName = row?.adtnlItmCdNo;
                if (!fieldName) continue;
                const originVal = String(row?.adtnlItmCn ?? "");
                const currentVal = String(allValues?.[fieldName] ?? "");
                if (originVal !== currentVal) return true;
            }
            return false;
        }, [form]),
        handleSaveSuccess: useCallback(() => {
            const allValues = form?.appRgstOfcrAddItm ?.getValues?.() || {};
            const originList = [...(allValues?.orginAdtnlItmList || [])];
            const nextOrigin = originList.map((row: any) => {
                const key = row?.adtnlItmCdNo;
                return {
                    ...row,
                    adtnlItmCn: key ? allValues[key] : row?.adtnlItmCn,
                };
            });
            form.appRgstOfcrAddItm ?.setValue("orginAdtnlItmList", nextOrigin);
            onOfcrAddItmChange?.(false);
        }, [form, onOfcrAddItmChange]),
        saveOfcrAddItm: useCallback(async (): Promise<boolean> => {
            return new Promise<boolean>((resolve) => {
                modal.openModal({
                    content: "msg.osc.00058",
                    onConfirm: () => {
                        void (async () => {
                            const values = form?.appRgstOfcrAddItm ?.getValues?.() || {};
                            const originList = [...(values?.orginAdtnlItmList || [])];
                            const data = APIS_ADD_ITM.getSaveAddItmList(values, originList, props.itemNo);
                            const result = await fetch.saveAdtnlItmValueList.fetch(data);
                            if (!result || result?.isAxiosError || (result?.response && result?.response?.status >= 400)) {
                                resolve(false);
                                return;
                            }
                            handler.handleSaveSuccess();
                            resolve(true);
                        })();
                    },
                    onCancel: () => resolve(false),
                });
            });
        }, [form, props.itemNo, props.param, modal]),
        validOfcrAddItm: useCallback(async (): Promise<boolean> => {
            if (!stateAddItmSchemas || stateAddItmSchemas.length === 0) return true;
            const valid = await form.appRgstOfcrAddItm .validate();
            return !!valid;
        }, [form, stateAddItmSchemas]),
    };

    // useEffect(() => {
    //     // No officer additional items for pre-application !== 사전 신청서는 담당자 추가 항목 미표시 ==!
    //     if (isPreApp) {
    //         refAddItmList.current = [];
    //         setStateAddItmSchemas([]);
    //         return;
    //     }

    //     if (!props.param?.appId) return;
    //     if (isBefore) {
    //         // Before: 정정 전 appId만 바로 조회
    //         fetch.getAdtnlItmValueList.fetch(props.param.appId, paramData);
    //         return;
    //     }

    //     if (props.bfParam?.appId) {
    //         fetch.getBeforeAdtnlItmValueList.fetch(props.bfParam.appId, bfParamData);
    //     }
    // }, [displayMode, isPreApp, props.param?.appId, props.bfParam?.appId, areaCd, itemNo]);
    useEffect(() => {
        if (isPreApp) {
            refAddItmList.current = [];
            setStateAddItmSchemas([]);
            return;
        }

        if (!props.param?.appId) return;

        if (isBefore) {
            fetch.getAdtnlItmValueList.fetch(props.param.appId, paramData);
            return;
        }

        // Align with APP_AMD_DTL_ADD_ITM — wait for before keys !== 정정 전 키 준비 후 조회 ==!
        const bf = props.bfParam;
        if (!bf?.appId && !bf?.appCdNo) return;

        // const loadKey = `${props.param.appId}:${props.bfParam?.appId ?? ""}:${areaCd}:${itemNo ?? ""}`;
        // if (loadedKeyRef.current === loadKey) return;

        // loadedKeyRef.current = loadKey;

        // fetch.getBeforeAdtnlItmValueList.fetch(bf.appId, bfParamData);

        const loadKey = `${props.param.appId}:${props.bfParam?.appId ?? ""}:${areaCd}:${itemNo ?? ""}`;
        if (loadedKeyRef.current === loadKey) return;
        loadedKeyRef.current = loadKey;
        refBfList.current = [];
        if (!bf?.appId) return;
        fetch.getBeforeAdtnlItmValueList.fetch(bf.appId, bfParamData);

        // if (props.bfParam?.appId) {
        //     fetch.getBeforeAdtnlItmValueList.fetch(props.bfParam.appId, bfParamData);
        // } else {
        //     fetch.getAdtnlItmValueList.fetch(props.param.appId, paramData);
        // }
    }, [displayMode, isPreApp, isBefore, props.param?.appId, props.bfParam?.appId, props.param?.prcsRoleTpCd, areaCd, itemNo]);

    // useEffect(() => {
    //     if (isBefore || !canEditAfter || !ofcrAddItmForm?.watch) return;
    //     if (!stateAddItmSchemas || stateAddItmSchemas.length === 0) return;
    //     const subscription = ofcrAddItmForm.watch(() => {
    //         const changed = handler.isChangeByOrigin();
    //         onOfcrAddItmChangeRef.current?.(changed);
    //     });
    //     return () => subscription?.unsubscribe?.();
    // }, [isBefore, canEditAfter, ofcrAddItmForm, stateAddItmSchemas, handler.isChangeByOrigin]);
    useEffect(() => {
        if (!onOfcrAddItmChange || !canEditAfter) return;
        if (!stateAddItmSchemas?.length) return;
        onOfcrAddItmChange(handler.isChangeByOrigin());
    }, [watchedValues, stateAddItmSchemas, canEditAfter, handler.isChangeByOrigin, onOfcrAddItmChange]);

    useEffect(() => {
        if (isBefore || !canEditAfter) return;
        onRegisterTabSave?.(props.area, async () => handler.saveOfcrAddItm());
    }, [isBefore, canEditAfter, onRegisterTabSave, props.area, handler.saveOfcrAddItm]);

    useEffect(() => {
        if (isBefore || !canEditAfter) return;
        onRegisterTabValid?.(props.area, async () => handler.validOfcrAddItm());
    }, [isBefore, canEditAfter, onRegisterTabValid, props.area, handler.validOfcrAddItm]);
    
    // Rebuild After schemas only when edit flag toggles !== 편집 플래그 변경 시에만 After 스키마 재적용 ==!
    useEffect(() => {
        if (isPreApp) return;
        if (isBefore || !ofcrAddItmForm) return;
        if (prevCanEditAfterRef.current === canEditAfter) return;
        
        prevCanEditAfterRef.current = canEditAfter;
        
        const list = refAddItmList.current;
        if (!list || list.length === 0) return;

        const bfOrigin = resolveBfOrigin();

        setStateAddItmSchemas(
            APIS_ADD_ITM.getAmdAdtnlItmSchemas(ofcrAddItmForm, list, canEditAfter, bfOrigin, { hydrateValues: false }),
        );

        ofcrAddItmForm.setEditable(!!canEditAfter);
    }, [isBefore, canEditAfter, ofcrAddItmForm, bfOfcrAddItmForm]);
    
    // // Re-apply compare styles when before origin is loaded !== 정정 전 목록 로드 후 비교 스타일 재적용 ==!
    // useEffect(() => {
    //     if (isPreApp || isBefore || !ofcrAddItmForm) return;
    //     const list = refAddItmList.current;
    //     if (!list?.length) return;
    //     const bfOrigin = bfOfcrAddItmForm?.getValues?.()?.orginAdtnlItmList || [];
    //     if (!bfOrigin?.length) return;
    //     setStateAddItmSchemas(
    //         APIS_ADD_ITM.getAmdAdtnlItmSchemas(ofcrAddItmForm, list, canEditAfter, bfOrigin),
    //     );
    //     ofcrAddItmForm.setEditable(!!canEditAfter);
    // }, [isBefore, isPreApp, canEditAfter, ofcrAddItmForm, bfOfcrAddItmForm, props.bfParam?.appId]);

    return (
        <>
            {stateAddItmSchemas && stateAddItmSchemas.length > 0 && (
                <Layout direction="col">
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={"T_ADTNL_INFO_LPCO"} titleSize={1}></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        {stateAddItmSchemas.map((elem, idx) => {
                            const fieldSchema = form.appRgstOfcrAddItm?.schema?.[elem.inputName] ?? {};
                            // !== 그 화면 롤 기준 편집 가능(EDIT_YN != 'N')일 때만 편집 ==!
                            const roleEditable = canEditAfter && refAddItmList.current[idx]?.editYn !== "N";
                            // View mode: show warning border via read-only input !== 조회 시(또는 편집불가 롤) 변경 필드는 readOnly input으로 테두리 표시 ==!
                            const controlEdit = roleEditable || (!roleEditable && (fieldSchema.readOnly === true || fieldSchema.borderColor === "warning"));
                        
                            let rightButton = null;
                            if (refAddItmList.current[idx]?.inpTpCd === "CP") {
                                rightButton = APIS_ADD_ITM.getFormRightButtonCP(
                                    elem.inputName,
                                    elem.comnCd,
                                    form.appRgstOfcrAddItm ,
                                    modal,
                                );
                            } else if (refAddItmList.current[idx]?.inpTpCd === "SP") {
                                rightButton = APIS_ADD_ITM.getFormRightButtonPP(
                                    elem.inputName,
                                    refAddItmList.current[idx]?.adtnlItmCdNo,
                                    form.appRgstOfcrAddItm ,
                                    modal,
                                );
                            }
                            if (refAddItmList.current[idx]?.inpTpCd !== "CP") {
                                refTemp.current.push(
                                    <Group.Control
                                        key={elem.inputName}
                                        {...form.appRgstOfcrAddItm.schema[elem.inputName]}
                                        edit={controlEdit}
                                        rightButton={rightButton}
                                    />,
                                );
                            } else {
                                refTemp.current.push(
                                    APIS_ADD_ITM.getFormComponentComnCd(
                                        elem,
                                        form.appRgstOfcrAddItm ,
                                        elem.inputName,
                                        rightButton,
                                        controlEdit,
                                    ),
                                );
                            }
                            if (idx % 2 === 1 || idx === stateAddItmSchemas.length - 1) {
                                const temp = [...refTemp.current];
                                refTemp.current = [];
                                return <Group.Row key={`${elem.inputName}_${idx}`}>{temp}</Group.Row>;
                            }
                            return null;
                        })}
                    </Group.Section>
                </Layout>
            )}
        </>
    );
};